import React from "react";
import { ERRORS } from "./ActionTypes";
import history from "../../actions/history";
import initialState from "../../reducers/initialState";

import { toastr } from "react-redux-toastr";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";

const toastrOptions = {
  timeOut: 3000, // by setting to 0 it will prevent the auto close
  icon: <RemoveCircleIcon fontSize="large" />, // You can add any component you want but note that the width and height are 70px ;)
  attention: true,
  showCloseButton: false, // false by default
  closeOnToastrClick: false,
  newestOnTop: false,
  preventDuplicates: true,
  position: "top-center",
  transitionIn: "fadeIn",
  transitionOut: "fadeOut",
};

const execute403 = (state, action) => {
  //history.push("/dashboard/403");
  console.log(`error 403 ........`);
  //return { ...state, showErrorModal: true };
  toastr.error(`شما مجوز ورود به  بخش مورد نظر را ندارید!`, toastrOptions);
};
const execute404 = (state, action) => {
  history.push("/dashboard/404");
  return { ...state };
};
const execute802 = (state, action) => {
  window.location = "/NoService";
  return { ...state };
};

const execute500 = (state, action) => {
  //history.push("/dashboard/500");
  return { ...state };
};
const execute503 = (state, action) => {
  //history.push("/dashboard/503");
  toastr.warning(
    `سرویس هم اکنون در دسترس نمی باشد ! لطفا پس از مدتی مجددا سعی کنید!`,
    toastrOptions
  );
  return { ...state };
};

const executeOtherError = (state, action) => {
  //history.push("/dashboard/OtherError");
  //return { ...state };
  return {
    ...state,
    showErrorModal: true,
    errorMessage: action.error.response.data,
  };
};

const ErrorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ERRORS.HTTP_403_ERROR:
      return execute403(state, action);
    case ERRORS.HTTP_404_ERROR:
      return execute404(state, action);
    case ERRORS.HTTP_500_ERROR:
      return execute500(state, action);
    case ERRORS.HTTP_503_ERROR:
      return execute503(state, action);
    case ERRORS.HTTP_802_ERROR:
      return execute802(state, action);
    case ERRORS.HTTP_OTHER_ERROR:
      return executeOtherError(state, action);
    default:
      return state;
  }
};

export default ErrorsReducer;
